export const tickerItems: string[] = [
  '今晚 22:00 压轴档首发：顶流直播间幕后全记录',
  '「辟谣跑赢大瓜」专题上线，官方只回了一个字',
  '高能瓜点：跨年晚会临开场前 40 分钟换人',
  '劲爆细节：节目单被爆删除某主演名单',
  '顶配盘点：本季 10 大高能名场面已更新',
  '猛料速递：某剧组深夜被拍大箱撤离现场',
  '大瓜预警：明日 20:00 更有王炸级别爆料',
];

export interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  trend: 'up' | 'down' | 'flat';
}

export const hotRank: RankItem[] = [
  { rank: 1, title: '直播电商一姐疑似失联，公司回应口径反复', tag: '高能', heat: 982, trend: 'up' },
  { rank: 2, title: '顶流男星录音再被扒出，内容劲爆程度超预期', tag: '劲爆', heat: 941, trend: 'up' },
  { rank: 3, title: '跨年阵容大换血，某新晋小花临时空降', tag: '大瓜', heat: 900, trend: 'up' },
  { rank: 4, title: '知名导演被爆带资进组，亲口证实只因一条私信', tag: '猛料', heat: 867, trend: 'down' },
  { rank: 5, title: '综艺神剪辑翻车，正片与花絮出入过大被群嘲', tag: '辟谣', heat: 812, trend: 'flat' },
  { rank: 6, title: '昔日顶配 CP 各自官宣，评论区一夜沦陷', tag: '高能', heat: 786, trend: 'down' },
  { rank: 7, title: '压轴大瓜：某颁奖礼后台对话录音流出', tag: '压轴', heat: 743, trend: 'up' },
  { rank: 8, title: '代言续约突然告吹，品牌方删光合作物料', tag: '猛料', heat: 698, trend: 'flat' },
  { rank: 9, title: '练习生宿舍监控被黑，经纪公司紧急声明', tag: '劲爆', heat: 655, trend: 'down' },
  { rank: 10, title: '年度盛典席位名单流出，多方经纪人连夜改口', tag: '大瓜', heat: 612, trend: 'flat' },
];

export interface TagItem {
  name: string;
  heat: number;
  tone: 'fire' | 'amber' | 'paper';
}

export const tagWall: TagItem[] = [
  { name: '猛料', heat: 99, tone: 'fire' },
  { name: '大瓜', heat: 96, tone: 'fire' },
  { name: '高能', heat: 92, tone: 'amber' },
  { name: '劲爆', heat: 90, tone: 'fire' },
  { name: '压轴', heat: 88, tone: 'amber' },
  { name: '顶配', heat: 84, tone: 'amber' },
  { name: '辟谣', heat: 80, tone: 'paper' },
  { name: '塌房', heat: 78, tone: 'fire' },
  { name: '后台', heat: 74, tone: 'paper' },
  { name: '实锤', heat: 72, tone: 'fire' },
  { name: '反转', heat: 68, tone: 'amber' },
  { name: '录音', heat: 64, tone: 'fire' },
  { name: '聊天记录', heat: 62, tone: 'paper' },
  { name: '名场面', heat: 58, tone: 'amber' },
  { name: '时间线', heat: 55, tone: 'paper' },
  { name: '知情人士', heat: 52, tone: 'fire' },
  { name: '声明对比', heat: 50, tone: 'paper' },
  { name: '考古现场', heat: 48, tone: 'amber' },
  { name: '串瓜', heat: 46, tone: 'fire' },
  { name: '催更', heat: 42, tone: 'paper' },
];

export interface FeedItem {
  cat: string;
  tag: string;
  title: string;
  summary: string;
  cover: string;
  views: string;
  replies: string;
  time: string;
}

export const feeds: FeedItem[] = [
  {
    cat: '高能',
    tag: '高能',
    title: '直播电商一姐疑似失联：最后一场直播切了 8 分钟静音',
    summary: '从镜头前情绪崩溃到后台离场，全程时间线逐帧复盘，劲爆细节一个不落。',
    cover: 'https://readdy.ai/api/search-image?query=Backlit%20silhouette%20of%20a%20solo%20female%20host%20on%20an%20empty%20neon%20stage%20under%20a%20single%20red%20spotlight%2C%20dramatic%20editorial%20tabloid%20newsroom%20aesthetic%2C%20heavy%20atmospheric%20haze%2C%20warm%20crimson%20and%20amber%20tones%2C%20cinematic%20film%20grain%2C%20high%20contrast%2C%20mysterious%20and%20intense%20mood&width=720&height=960&seq=cover-hot-01&orientation=portrait',
    views: '382.6万',
    replies: '2.4万',
    time: '12 分钟前',
  },
  {
    cat: '大瓜',
    tag: '大瓜',
    title: '跨年阵容大换血：某新晋小花凌晨 3 点空降彩排现场',
    summary: '官方名单与彩排路透严重不符，多方知情人士的说法拼出完整拼图。',
    cover: 'https://readdy.ai/api/search-image?query=Empty%20grand%20concert%20stage%20backstage%20at%20night%20with%20a%20lone%20spotlight%20and%20scattered%20production%20lights%2C%20crowd%20silhouettes%20blurred%20in%20distance%2C%20editorial%20gossip%20newsroom%20mood%2C%20warm%20amber%20and%20dark%20red%20palette%2C%20cinematic%20haze%2C%20film%20grain&width=720&height=960&seq=cover-hot-02&orientation=portrait',
    views: '301.2万',
    replies: '1.8万',
    time: '28 分钟前',
  },
  {
    cat: '劲爆',
    tag: '劲爆',
    title: '顶流男星录音片段再流出：争议内容被逐句标注',
    summary: '三段录音拼接出完整语境，网友整理的逐句比对表冲上热榜。',
    cover: 'https://readdy.ai/api/search-image?query=Studio%20recording%20booth%20with%20a%20vintage%20microphone%20in%20dark%20warm%20light%2C%20sound%20wave%20and%20cable%20shadows%2C%20editorial%20gossip%20tabloid%20aesthetic%2C%20deep%20red%20and%20amber%20tones%2C%20moody%20cinematic%20atmosphere%2C%20film%20grain%2C%20high%20contrast&width=720&height=960&seq=cover-hot-03&orientation=portrait',
    views: '289.5万',
    replies: '1.6万',
    time: '41 分钟前',
  },
  {
    cat: '辟谣',
    tag: '辟谣',
    title: '「黑料王」回应删名单：只发了一个字却掀起新瓜',
    summary: '辟谣声明与考古旧帖对不上号，网友直呼这波又反转了。',
    cover: 'https://readdy.ai/api/search-image?query=Stack%20of%20old%20magazines%20and%20newspapers%20on%20a%20table%20under%20warm%20desk%20lamp%2C%20torn%20headline%20pages%20in%20focus%2C%20editorial%20retro%20gossip%20newsroom%20aesthetic%2C%20warm%20amber%20and%20rust%20tones%2C%20cinematic%20shallow%20depth%20of%20field%2C%20film%20grain&width=720&height=960&seq=cover-hot-04&orientation=portrait',
    views: '244.8万',
    replies: '1.2万',
    time: '55 分钟前',
  },
  {
    cat: '高能',
    tag: '高能',
    title: '年度盛典席位流出：颁奖礼后台录音完整时间线',
    summary: '从候场到领奖全程 90 分钟被逐段复盘，压轴环节疑点最多。',
    cover: 'https://readdy.ai/api/search-image?query=Golden%20award%20trophy%20blurred%20on%20red%20carpet%20night%20with%20bokeh%20crowd%20lights%20and%20flash%2C%20celebratory%20yet%20mysterious%20editorial%20tabloid%20mood%2C%20warm%20gold%20and%20deep%20crimson%20palette%2C%20cinematic%2C%20film%20grain&width=720&height=960&seq=cover-hot-05&orientation=portrait',
    views: '218.3万',
    replies: '9876',
    time: '1 小时前',
  },
  {
    cat: '猛料',
    tag: '猛料',
    title: '知名导演被爆带资进组：一条私信牵出整条选角链',
    summary: '聊天记录截图拼出选角内幕，多名工作人员的说法高度一致。',
    cover: 'https://readdy.ai/api/search-image?query=Hands%20holding%20a%20glowing%20smartphone%20showing%20blurred%20chat%20bubbles%20at%20night%2C%20dark%20cinematic%20editorial%20background%2C%20warm%20amber%20screen%20glow%20against%20deep%20red%20shadows%2C%20gossip%20newsroom%20aesthetic%2C%20film%20grain&width=720&height=960&seq=cover-hot-06&orientation=portrait',
    views: '196.4万',
    replies: '8651',
    time: '1 小时前',
  },
  {
    cat: '大瓜',
    tag: '大瓜',
    title: '神剪辑翻车风波升级：正片花絮逐帧对比刷屏',
    summary: '同一位嘉宾两种画面，二次剪辑疑点被扒得底朝天。',
    cover: 'https://readdy.ai/api/search-image?query=Film%20editing%20suite%20with%20dual%20monitors%20showing%20timeline%20and%20clapperboard%20in%20dark%20room%2C%20warm%20red%20and%20amber%20monitor%20glow%2C%20editorial%20documentary%20aesthetic%2C%20cinematic%20atmosphere%2C%20film%20grain&width=720&height=960&seq=cover-hot-07&orientation=portrait',
    views: '174.2万',
    replies: '7422',
    time: '1 小时前',
  },
  {
    cat: '劲爆',
    tag: '劲爆',
    title: '练习生宿舍监控被黑：经纪公司深夜紧急声明',
    summary: '从泄漏源头到内鬼排查，黑料王整理的脉络图一目了然。',
    cover: 'https://readdy.ai/api/search-image?query=Darkened%20dormitory%20hallway%20at%20night%20seen%20through%20a%20security%20camera%20fisheye%20view%2C%20moody%20surveillance%20aesthetic%2C%20deep%20shadows%20with%20warm%20amber%20accents%2C%20editorial%20crime-doc%20gossip%20mood%2C%20cinematic%20film%20grain&width=720&height=960&seq=cover-hot-08&orientation=portrait',
    views: '152.7万',
    replies: '6910',
    time: '2 小时前',
  },
  {
    cat: '高能',
    tag: '高能',
    title: '昔日顶配 CP 各自官宣：评论区 20 分钟沦陷',
    summary: '两条官宣同框截图疯传，粉丝考古帖与吃瓜名场面齐飞。',
    cover: 'https://readdy.ai/api/search-image?query=Two%20empty%20director%20chairs%20side%20by%20side%20facing%20away%20on%20a%20dark%20stage%20with%20warm%20backlight%2C%20symbolic%20and%20dramatic%2C%20editorial%20gossip%20tabloid%20aesthetic%2C%20deep%20red%20and%20amber%20palette%2C%20cinematic%20haze%2C%20film%20grain&width=720&height=960&seq=cover-hot-09&orientation=portrait',
    views: '133.9万',
    replies: '5.7万',
    time: '2 小时前',
  },
  {
    cat: '猛料',
    tag: '猛料',
    title: '代言续约突然告吹：品牌方连夜删光全部物料',
    summary: '从官宣到删光的 72 小时，广告商内部口径出现分歧。',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20billboard%20advertisement%20being%20dismantled%20at%20night%20by%20workers%20under%20crane%20lights%2C%20striking%20editorial%20news%20photo%20aesthetic%2C%20cool%20night%20with%20warm%20amber%20work%20lights%20and%20red%20accents%2C%20cinematic%2C%20film%20grain&width=720&height=960&seq=cover-hot-10&orientation=portrait',
    views: '118.6万',
    replies: '5320',
    time: '3 小时前',
  },
  {
    cat: '大瓜',
    tag: '大瓜',
    title: '压轴大瓜：某颁奖礼候场画面被逐一放大解读',
    summary: '座位间隔、表情微动作、后台动线，吃瓜名场面全复盘。',
    cover: 'https://readdy.ai/api/search-image?query=Luxurious%20red%20carpet%20entrance%20at%20night%20with%20velvet%20rope%20and%20bright%20spotlights%2C%20elegant%20crowd%20silhouettes%2C%20dramatic%20editorial%20tabloid%20aesthetic%2C%20deep%20crimson%20and%20warm%20gold%20palette%2C%20cinematic%20bokeh%2C%20film%20grain&width=720&height=960&seq=cover-hot-11&orientation=portrait',
    views: '104.3万',
    replies: '4211',
    time: '3 小时前',
  },
  {
    cat: '劲爆',
    tag: '劲爆',
    title: '节目单被爆删除某主演名字：导演凌晨直播回应',
    summary: '从删名单到补位换人，被影响的档期链全部浮出水面。',
    cover: 'https://readdy.ai/api/search-image?query=A%20blurred%20figure%20walking%20alone%20through%20an%20empty%20airport%20terminal%20at%20night%20with%20giant%20departure%20board%20glow%2C%20melancholic%20and%20mysterious%20editorial%20documentary%20mood%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20film%20grain&width=720&height=960&seq=cover-hot-12&orientation=portrait',
    views: '92.8万',
    replies: '3980',
    time: '4 小时前',
  },
];

export interface TimelineItem {
  time: string;
  title: string;
  tag: string;
  detail: string;
  pic: string;
}

export const timeline: TimelineItem[] = [
  {
    time: '22:15',
    tag: '压轴档',
    title: '压轴档首发：顶流直播间幕后全记录上线',
    detail: '迟到 40 分钟的开播、中段 8 分钟静音、最后一句未说完的话，黑料王逐帧复盘首发。',
    pic: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20control%20room%20with%20multiple%20glowing%20monitors%20and%20camera%20silhouettes%20at%20night%2C%20urgent%20editorial%20broadcast%20aesthetic%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%2C%20film%20grain&width=480&height=300&seq=timeline-01&orientation=landscape',
  },
  {
    time: '21:40',
    tag: '大瓜',
    title: '跨年晚会阵容变更被曝：官方名单悄悄删了两行',
    detail: '多名知情人士透露临开场前 40 分钟完成换人，彩排路透流出印证。',
    pic: 'https://readdy.ai/api/search-image?query=Concert%20lighting%20rig%20silhouettes%20against%20smoky%20stage%20haze%20before%20showtime%2C%20crowd%20waiting%20in%20dark%2C%20editorial%20event%20news%20mood%2C%20warm%20amber%20spotlights%20and%20deep%20red%20ambiance%2C%20cinematic%2C%20film%20grain&width=480&height=300&seq=timeline-02&orientation=landscape',
  },
  {
    time: '20:50',
    tag: '劲爆',
    title: '录音话题热度再飙升：逐句标注版全网转发',
    detail: '三段录音拼出的完整语境让讨论量一小时内翻倍，话题墙被顶上首位。',
    pic: 'https://readdy.ai/api/search-image?query=Vintage%20microphone%20and%20audio%20waveform%20on%20dark%20mixing%20console%2C%20warm%20amber%20LEDs%20glowing%2C%20editorial%20audio%20forensics%20aesthetic%2C%20deep%20red%20shadows%2C%20cinematic%2C%20film%20grain&width=480&height=300&seq=timeline-03&orientation=landscape',
  },
  {
    time: '19:30',
    tag: '辟谣',
    title: '「黑料王」发辟谣声明：一个字掀起新一轮反转',
    detail: '声明用词与考古旧帖对不上号，评论区连夜整理出八处疑点。',
    pic: 'https://readdy.ai/api/search-image?query=Newsroom%20desk%20with%20scattered%20printed%20statements%2C%20sticky%20notes%20and%20coffee%20cup%20under%20warm%20lamp%2C%20editorial%20investigative%20mood%2C%20amber%20and%20rust%20tones%2C%20shallow%20depth%20of%20field%2C%20film%20grain&width=480&height=300&seq=timeline-04&orientation=landscape',
  },
];

export interface FeaturedItem {
  tag: string;
  title: string;
  desc: string;
  cover: string;
}

export const featured: FeaturedItem[] = [
  {
    tag: '顶配',
    title: '本季 10 大高能名场面封神榜',
    desc: '从切静音到删名单，每一幕都值得二刷的压轴级瞬间。',
    cover: 'https://readdy.ai/api/search-image?query=Golden%20spotlight%20bursting%20through%20dark%20smoke%20on%20an%20empty%20stage%2C%20dramatic%20editorial%20awards%20aesthetic%2C%20warm%20gold%20and%20deep%20crimson%20palette%2C%20cinematic%2C%20film%20grain&width=480&height=640&seq=featured-01&orientation=portrait',
  },
  {
    tag: '压轴',
    title: '年度盛典后台 90 分钟全景复盘',
    desc: '候场动线、座位暗语、领奖微表情，压轴大瓜一网打尽。',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20roped-off%20corridor%20at%20night%20under%20warm%20chandelier%20light%2C%20mysterious%20glamour%2C%20editorial%20tabloid%20aesthetic%2C%20crimson%20and%20gold%20tones%2C%20cinematic%2C%20film%20grain&width=480&height=640&seq=featured-02&orientation=portrait',
  },
  {
    tag: '猛料',
    title: '选角内幕全链条时间线',
    desc: '一条私信如何牵出整条带资链，聊天记录逐段还原。',
    cover: 'https://readdy.ai/api/search-image?query=Filmmaker%20clapperboard%20and%20a%20stack%20of%20audition%20headshots%20on%20dark%20director%20desk%20under%20warm%20lamp%2C%20editorial%20documentary%20aesthetic%2C%20amber%20and%20rust%20tones%2C%20cinematic%20shallow%20depth%2C%20film%20grain&width=480&height=640&seq=featured-03&orientation=portrait',
  },
  {
    tag: '高能',
    title: '顶配 CP 拆伙全记录',
    desc: '两条官宣同框截图疯传，粉丝与吃瓜党各执一词。',
    cover: 'https://readdy.ai/api/search-image?query=Two%20dramatic%20chair%20silhouettes%20facing%20apart%20in%20smoky%20red%20spotlight%2C%20symbolic%20split%20moment%2C%20editorial%20gossip%20aesthetic%2C%20deep%20crimson%20and%20warm%20amber%2C%20cinematic%20haze%2C%20film%20grain&width=480&height=640&seq=featured-04&orientation=portrait',
  },
];

export interface CommentItem {
  user: string;
  role: string;
  text: string;
  likes: string;
  tone: 'fire' | 'amber' | 'paper';
}

export const comments: CommentItem[] = [
  {
    user: '瓜友@一只鸽子',
    role: '围观前排',
    text: '坐等压轴档，黑料王家的时间线复盘从来不含糊，前排占个位。',
    likes: '1.2万',
    tone: 'fire',
  },
  {
    user: '@熬夜考古员',
    role: '考古区主力',
    text: '这波劲爆程度超出预期，逐句标注版比官方声明信息量大太多了。',
    likes: '8603',
    tone: 'amber',
  },
  {
    user: '@今天也吃瓜',
    role: '串瓜十级',
    text: '好家伙，评论区连时间线都拼出来了，高能程度顶配不解释。',
    likes: '5721',
    tone: 'fire',
  },
  {
    user: '@理性在线',
    role: '吃瓜路人',
    text: '先蹲一个官方回应，猛料归猛料，瓜还得熟了再吃才香。',
    likes: '4310',
    tone: 'paper',
  },
];

export const subscribeHooks: string[] = ['30 秒定位当季高能现场', '第一时间收到压轴档提醒', '仅接收黑料王猛料与大瓜精选', '随时可退订，不骚扰'];